import React from 'react';
import success from '../../../../assets/Images/svg/success-mail.svg';
import { useParams } from 'react-router-dom';

export default function Complete() {
    const { lang } = useParams();
    return (
        <div className="text-center py-56 text-black space-y-2">
            <div>
                <img src={success} alt="" />
            </div>
            <div className="font-medium text-4xl text-[#7B67FB]">
                {lang === 'en'
                    ? 'Your data was sent successfully.'
                    : 'ส่งข้อมูลสำเร็จ'}
            </div>
            <div className="text-[#65707A] text-1xl font-medium">
                {lang === 'en'
                    ? 'We have received your information.'
                    : 'เราได้รับข้อมูลของคุณแล้ว'}
            </div>
        </div>
    );
}
